export const replaceCommon = (word: string, prev: any, after: any) =>
  word.replace(prev, after);

export const replaceUnderscoreToSpace = (word: string) =>
  replaceCommon(word, "_", " ");

export const CapitalizeFirstLetter = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1);

export const formatKeyName = (word: string) => {
  // Insert a space before each capital letter, capitalize the first letter
  const formatted = word
    .replace(/([A-Z])/g, " $1") // add space before uppercase letters
    .replace(/^./, (str) => str.toUpperCase()); // capitalize first letter

  return formatted.trim();
}



export const ReplaceSpaceAfterCapitalLetter = (word: string) =>
  replaceCommon(word, /([a-z])([A-Z])/g, "$1 $2");

export const convertDecimalPoint = (string: string) =>
  parseFloat(string).toFixed(2);
